import { z } from "zod";

export const InsightKind = {
	TREND: "trend",
	COMPARISON: "comparison",
	SUMMARY: "summary",
	ALERT: "alert",
} as const;

export type InsightKind = (typeof InsightKind)[keyof typeof InsightKind];

export const INSIGHT_KINDS = Object.values(InsightKind) as readonly InsightKind[];

export const insightKindSchema = z.enum(InsightKind);
